import script from "./CountsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CountsBlock.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__